'use strict';
module.exports = () => () => {};
